var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import UtilCref from '@cewe-designsystem/util_cref';
/**
 * Utility for handling trading partner data.
 * It can be used for determining the available order channels of products.
 */
export default class UtilTradingPartner {
    /**
     * @constructor
     * @param {string} dataPath The path of the JSON files containing the trading partner data from @cewe-tradingpartner/trading-partner-data
     * @param {number|null} keyAccount
     */
    constructor(dataPath, keyAccount) {
        /**
         * Data cache
         */
        this.dataCache = {};
        this.dataPath = dataPath;
        this.setCrefUtil(new UtilCref(keyAccount === null || keyAccount === void 0 ? void 0 : keyAccount.toString()));
    }
    /**
     * Set the Cref Util
     * @param crefUtil
     */
    setCrefUtil(crefUtil) {
        this.crefUtil = crefUtil;
    }
    /**
     * Get the order channels of a product
     *
     * @param {number} productId Id of the product
     * @param {number} keyAccountId Id of the key account
     * @param {string} language The lower-cased ISO 639-1 language code (e.g. "de")
     * @param {string} country The upper-cased code (e.g. "DE")
     * @param {string} project The Eos project slug (e.g. "cops-5" or "cewe-de")
     * @return {Promise<TradingPartnerOrderChannels>} Order channels of the product
     */
    getProductOrderChannels(productId, keyAccountId, language, country, project) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                if (!this.dataPath) {
                    return reject('TradingPartnerUtil: Please set data path!');
                }
                if (this.dataCache[productId]) {
                    // The product data is available in the cache
                    if (this.dataCache[productId] &&
                        this.dataCache[productId][keyAccountId] &&
                        this.dataCache[productId][keyAccountId][language]) {
                        return resolve(this.dataCache[productId][keyAccountId][language]);
                    }
                    else {
                        return resolve({});
                    }
                }
                // Product information not found in cache
                try {
                    const url = `${this.dataPath}/${productId}.json?productId=${productId}&keyAccount=${keyAccountId}&project=${project}&language=${language}&country=${country}`;
                    fetch(url)
                        .then((response) => response.text())
                        .then((txtResponse) => {
                        this.dataCache[productId] = JSON.parse(this.crefUtil.replacePlaceholder(txtResponse));
                        if (this.dataCache[productId] &&
                            this.dataCache[productId][keyAccountId] &&
                            this.dataCache[productId][keyAccountId][language]) {
                            return resolve(this.dataCache[productId][keyAccountId][language]);
                        }
                        else {
                            return resolve({});
                        }
                    });
                }
                catch (e) {
                    return reject(`TradingPartnerUtil: Data not reachable. Please check the data path! Error: ${e.message}`);
                }
            });
        });
    }
}
